import { useCallback } from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { useRootPaneNavigation } from '../../../utils/deepLink/useDeepLinkSegment';

/**
 * Cross-pane deep link for the deck detail panes. One call does the whole
 * bridge: fires the `xpanel_*` analytics event (fire-and-forget — telemetry
 * must never block navigation), switches the root pane tab, optionally seeds
 * params scoped under the destination pane (e.g. preselect a card in the
 * synergy drilldown), and scrolls the tab panel back into view so the
 * destination opens at its top instead of wherever the user was.
 *
 * @returns {(target: string, opts?: { event?: string, params?: object }) => void}
 */
export function useDeckPaneCrossLink() {
    const navigateToPane = useRootPaneNavigation();
    return useCallback(
        (target, { event, params } = {}) => {
            try {
                logEvent(getAnalytics(), event || `xpanel_${target}`);
            } catch (_err) {
                // analytics not initialized / blocked — ignore
            }
            navigateToPane(target, { params });
            const tabPanel = document.getElementById('tabPanel');
            if (tabPanel) {
                window.scrollBy({ top: tabPanel.getBoundingClientRect().top, left: 0, behavior: 'smooth' });
            }
        },
        [navigateToPane]
    );
}
